import { ITheme, JssStyle } from '../../../styles/themes';
import {
    ISnackbarClasses,
    ISnackbarProviderClasses
} from '.';

export const SnackbarProviderClasses = (
    theme: ITheme
): ISnackbarProviderClasses<JssStyle> => ({
    container: {
        position: 'fixed',
        right: theme.spacing.small,
        bottom: theme.spacing.small,
        zIndex: 1100,
        display: 'flex',
        flexDirection: 'column',
        width: `calc(100vw - ${theme.spacing.large}px)`,
        maxWidth: 420,
        pointerEvents: 'none',

        [theme.mediaQueries.extraSmallDown]: {
            right: theme.spacing.extraSmall,
            bottom: theme.spacing.extraSmall,
            left: theme.spacing.extraSmall,
            width: 'auto',
            maxWidth: 'none'
        }
    }
});

export const SnackbarClasses = (
    theme: ITheme
): ISnackbarClasses<JssStyle> => ({
    snackbar: {
        display: 'flex',
        alignItems: 'center',
        boxSizing: 'border-box',
        minHeight: 48,
        marginTop: theme.spacing.extraSmall,
        padding: '12px 10px 12px 16px',
        borderRadius: 4,
        boxShadow: '0 3px 8px rgba(0, 0, 0, 0.28)',
        fontFamily: theme.fonts.primary.family,
        fontSize: theme.fonts.primary.size,
        lineHeight: 1.4,
        opacity: 0,
        pointerEvents: 'auto',
        transform: 'translateX(24px)',
        transition: 'opacity 200ms ease, transform 200ms ease',

        '@media (prefers-reduced-motion: reduce)': {
            transform: 'none',
            transition: 'none'
        }
    },
    open: {
        opacity: 1,
        transform: 'translateX(0)'
    },
    closing: {
        opacity: 0,
        transform: 'translateX(24px)'
    },
    success: {
        color: theme.colors.white.rgb().toString(),
        backgroundColor: theme.themeColors.success.rgb().toString()
    },
    info: {
        color: theme.colors.white.rgb().toString(),
        backgroundColor: theme.themeColors.information.rgb().toString()
    },
    warning: {
        color: theme.themeColors.dark.rgb().toString(),
        backgroundColor: theme.themeColors.warning.rgb().toString()
    },
    error: {
        color: theme.colors.white.rgb().toString(),
        backgroundColor: theme.themeColors.danger.rgb().toString()
    },
    icon: {
        flex: '0 0 auto',
        marginRight: 12,
        fontSize: 20,
        lineHeight: 1
    },
    message: {
        flex: '1 1 auto',
        minWidth: 0,
        overflowWrap: 'break-word'
    },
    closeButton: {
        flex: '0 0 auto',
        alignSelf: 'stretch',
        margin: '-6px -4px -6px 8px',
        padding: '6px 8px',
        border: 0,
        borderRadius: 3,
        color: 'inherit',
        background: 'transparent',
        cursor: 'pointer',
        opacity: 0.8,

        '&:hover, &:focus': {
            background: 'rgba(0, 0, 0, 0.12)',
            opacity: 1,
            outline: 'none'
        },

        '&:focus-visible': {
            boxShadow: '0 0 0 2px currentColor'
        }
    }
});
